import i18n from 'i18nextInstance';

export const HEADERS = [{
    flex: 5,
    key: 'name',
    label: i18n.t('Cargo')
}];
